import { Box } from "@mui/material";

export const OssMetricCards = ({
  items = [], columns = { xs: 2, lg: 4 }, activeKey = "", onItemClick,
}) => (
  <Box className="oss-metric-strip" sx={{
    gridTemplateColumns: {
      xs: `repeat(${columns.xs || 2}, minmax(0, 1fr))`,
      md: `repeat(${columns.md || columns.lg || 4}, minmax(0, 1fr))`,
      lg: `repeat(${columns.lg || 4}, minmax(0, 1fr))`,
    },
  }}>
    {items.map((item) => {
      const clickable = Boolean(item.filterKey && onItemClick);
      const active = clickable && activeKey === item.filterKey;
      return (
        <Box key={item.label} component={clickable ? "button" : "div"}
          type={clickable ? "button" : undefined}
          className={"oss-metric" + (active ? " is-active" : "")}
          aria-pressed={clickable ? active : undefined}
          onClick={clickable ? () => onItemClick(item.filterKey) : undefined}
          style={{ "--metric-tone": item.tone || "#7163bd" }}>
          <span className="oss-metric-label">{item.label}</span>
          <span className="oss-metric-value">{item.value}<small>{item.unit}</small></span>
          {item.helper && <span className="oss-metric-helper">{item.helper}</span>}
        </Box>
      );
    })}
  </Box>
);
